
import connectorr from '../../../common/connector.js';
let connector = new connectorr();

var apiControllerConnector = "Generales";

export default {


    getCompannia(parametros) {  //ciaId

        return connector.Get(apiControllerConnector, "getCompannia", parametros);

    },

    GetListMonedas(parametros) { // ciaId

        return connector.Get(apiControllerConnector, "GetListMonedas", parametros);

    },

    GetMonedaById(parametros) { // ciaId, monedaId

        return connector.Get(apiControllerConnector, "GetMonedaById", parametros);

    },

    getListPaises(parametros) { // ciaId

        return connector.Get(apiControllerConnector, "getPaises", parametros);

    },

    getListProvincias(parametros) { // pai_pk

        return connector.Get(apiControllerConnector, "getProvincias", parametros);

    },

    getListCantones(parametros) { // pai_pk, provincia_id

        return connector.Get(apiControllerConnector, "getCantones", parametros);

    },

    getListDistritos(parametros) { // pai_pk, provincia_id, canton_id

        return connector.Get(apiControllerConnector, "getDistritos", parametros);

    },

    getListBarrios(parametros) { // pai_pk, provincia_id, canton_id, distrito_id

        return connector.Get(apiControllerConnector, "getBarrios", parametros);

    },

    postCompanniEdit(data) {

        return connector.Post(apiControllerConnector, "postCompanniEdit", data);

    },

    postCompanniAdd(data) {

        return connector.Post(apiControllerConnector, "postCompanniAdd", data);

    },

    getTiposPersona(parametros) { // ciaId, paisId

        return connector.Get(apiControllerConnector, "getTiposPersona", parametros);

    },

    //getUsuarios(parametros) { // token

    //    return connector.Get(apiControllerConnector, "getUsuarios", parametros);

    //},

    getUsuariosCia(parametros) { // ciaId, token

        return connector.Get(apiControllerConnector, "getUsuariosCia", parametros);

    },


    postInviteUser(parametros) {  //Datos, token

        return connector.PostForm(apiControllerConnector, "postInviteUser", parametros);

    },

    postEditUser(parametros) {  //Datos, token

        return connector.PostForm(apiControllerConnector, "postEditUser", parametros);

    },

    getDeleteUsuario(parametros) {  //ciaId, usuarioId, correo, token

        return connector.Get(apiControllerConnector, "getDeleteUsuario", parametros);

    },

    getAssignUsuario(parametros) {  //ciaId, usuarioId, correo, token

        return connector.Get(apiControllerConnector, "getAssignUsuario", parametros);

    },

    getUnassignUsuario(parametros) {  //ciaId, usuarioId, correo, token

        return connector.Get(apiControllerConnector, "getUnassignUsuario", parametros);

    },

    postSaveProfile(data) {  //Datos, token

        return connector.PostForm(apiControllerConnector, "postSaveProfile", data);

    },

    GetReportePagoBancos(parametros) {  // ciaId, token

        return connector.Get(apiControllerConnector, "GetReportePagoBancos", parametros);

    },

    GetReportesPagoPaginated(parametros) {  // ciaId, itemsPerPage, pagenumber, fechaInicio, fechaFinal, token

        return connector.Get(apiControllerConnector, "GetReportesPago", parametros);

    },

    PostReportePago(data) {

        return connector.Post(apiControllerConnector, "PostReportePago", data);

    },

    GetReportePago(parametros) {  // ciaId, reportePago_id, token

        return connector.Get(apiControllerConnector, "GetReportePago", parametros);

    },

    DeleteReportePago(parametros) {  // ciaId, reportePago_id, token

        return connector.Get(apiControllerConnector, "GetReportePagoDelete", parametros);

    },

    GetTiquetes(parametros) {  // ciaId, fechaInicio, fechaFinal

        return connector.Get(apiControllerConnector, "GetTiquetes", parametros);

    },

    PostTiquete(data) {

        return connector.Post(apiControllerConnector, "PostTiquete", data);

    },

    GetPlanIdFromToken(parametros) { // ciaId

        return connector.Get(apiControllerConnector, "GetPlanIdFromToken", parametros);

    },

    GetPaginatedListObservaciones(parametros) {  // ciaId, itemsPerPage, pagenumber, token

        return connector.Get(apiControllerConnector, "GetPaginatedListObservaciones", parametros);

    },

    AddObservacion(data) {

        return connector.Post(apiControllerConnector, "AddObservacion", data);

    }


}
